<template>
  <div>
    <h5 @click="load">Отчет</h5>
    <div class="table-full-width table-responsive">
      <table class=" table-rating">
        <thead>
          <tr>
            <th>Ученик</th>
            <th v-for="field in fields" :key="field.key">
              {{ field.title }}
            </th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="(client, key) in items" :key="client.id">
            <td>{{ key + 1 }}. {{ client.full_name  | maxChar(30) }}</td>
            <td v-for="field in fields" :key="field.key">
              {{ client[field.key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  created() {
    this.load()
  },
  data() {
    return {
      items: [],
      fields: [
        {
          title: 'Всего пропусков (уроки)',
          key: 'count_lesson_total'
        },
        {
          title: 'По уважительной (уроки)',
          key: 'count_lesson_valid'
        },
        {
          title: 'Всего пропусков (дни)',
          key: 'count_day_total'
        },
        {
          title: 'По уважительной (дни)',
          key: 'count_day_valid'
        },
        {
          title: 'Опозданий (уроки)',
          key: 'count_late'
        },
      ],
      name: 'discipline'
    };
  },
  props: ["group", "dataParams"],
  methods: {
    change(item) {
      this.$emit("input", item);
    },
    load() {
      this.$loading(true);
      this.$http
        .get(`business/groups/${this.group.id}/clients-timetables`, {
          params: this.dataParams
        })
        .then((response) => {
          this.items = response.data;
        })
        .catch((error) => {

        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });

    }
  },

  watch: {
    dataParams: {
      handler: function (val) {
        this.load();
      },
      deep: true,
      immediate: true,
    },
  }

};
</script>

